import type { IpgAllowedWebsite } from '../../../backend_config.types';

export const CloverOAuthAuthorizationState = {
    NOT_CONNECTED: 'NOT_CONNECTED',
    ACTIVE: 'ACTIVE',
    REAUTHORIZATION_REQUIRED: 'REAUTHORIZATION_REQUIRED',
    DISCONNECTED: 'DISCONNECTED',
} as const;

export type CloverOAuthAuthorizationState =
    (typeof CloverOAuthAuthorizationState)[keyof typeof CloverOAuthAuthorizationState];

export interface CloverOAuthAuthorizationStatus {
    readonly state: CloverOAuthAuthorizationState;
    readonly access_token_expires_ts: string | null;
    readonly refresh_token_expires_ts: string | null;
}

export interface StartCloverOAuthReauthorizationRequest {
    readonly organization_uuid: string;
}

export interface StartCloverOAuthReauthorizationResponse {
    readonly authorization_url: string;
    readonly expires_ts: string;
    readonly allowed_websites: readonly IpgAllowedWebsite[];
}
